import { CDNFileData, CDNFileGetApiResponse, CDNFileListApiResponse } from "../context/CDNFileContext/constants";
import { axiosInstance } from "../utils/axiosInstance";

export const ENDPOINTS = {
	ADD: "/cms/add-cdn-file",
	UPDATE: "/cms/update-cdn-file",
	GET: "/cms/get-cdn-file-details",
	LIST: "/cms/get-cdn-file-list",
	REMOVE: "/cms/remove-cdn-file"
};

export class CDNFileService {
	static async addCDNFile(cdnData: CDNFileData) {
		const formData = new FormData();
		formData.append("name", cdnData.name);

		if (cdnData.image) {
			formData.append("image", cdnData.image);
		}

		const response = await axiosInstance.post(`${ENDPOINTS.ADD}`, formData);
		return response.data;
	}

	static async getCDNFileList(): Promise<CDNFileListApiResponse> {
		const response = await axiosInstance.get(`${ENDPOINTS.LIST}`);
		return response.data;
	}

	static async getCDNFileDetail(cdnFileId: string): Promise<CDNFileGetApiResponse> {
		const response = await axiosInstance.get(`${ENDPOINTS.GET}?cdnFileId=${cdnFileId}`);
		return response.data;
	}

	static async updateCDNFile(cdnData: CDNFileData) {
		const formData = new FormData();

		if (cdnData.cdnFileId !== undefined) {
			formData.append("cdnFileId", cdnData.cdnFileId);
		}	 

		if (cdnData.name.trim()) {
			formData.append("name", cdnData.name);
		}	 

		if (cdnData.image) {
			formData.append("image", cdnData.image);
		}

		const response = await axiosInstance.patch(`${ENDPOINTS.UPDATE}`, formData);
		return response.data;
	}

	static async removeCDNFile(cdnFileId: string) {
		const response = await axiosInstance.delete(`${ENDPOINTS.REMOVE}?cdnFileId=${cdnFileId}`);
		return response.data;
	}
}
